<template>
  <div class="upload-image">
    <div class="upload-image__item">
      <a-icon
        v-if="!isOnlyView && editPermission"
        type="menu"
        class="drag-icon handle upload-image__handle__icon upload-image__handle__icon__hide"
        :class="{'upload-image__handle__icon__show mr-2' : mediaArrLength > 1}"
      />
      <div class="upload-image__item__content">
        <ImageWithBlurHash
          :imageSrc="media.src"
          :blurhash="media.blurhash"
          :width="150"
          :height="150"
          :alt="`${index + 1} Media image`"
          :timeoutBlurHash="100"
        />
        <div class="actions" v-if="!isOnlyView && deletePermission">
          <div class="actions__button-container">
            <div class="actions__button cursor-pointer" @click="deleteImage">
              <a-icon type="delete" class="text-red font-size-20" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWithBlurHash from '@/components/custom/image/ImageWithBlurHash.vue'

export default {
  props: {
    editPermission: {
      type: Boolean,
      default: false,
    },
    deletePermission: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    mediaArrLength: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ImageWithBlurHash,
  },
  computed: {
    isOnlyView() {
      return this.$route.name === 'view-avatars'
    },
  },
  methods: {
    deleteImage() {
      this.$emit('delete')
    },
  },
}
</script>

<style lang="scss">
.upload-image {
  margin-top: 20px;
  &__item {
    display: flex;
    &__content {
      position: relative;
      border-radius: 4px;
      .actions {
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #0a0a0a99;
        border-radius: 4px;
        overflow: hidden;
        opacity: 0;
        transition: all 0.5s ease;
        &:hover {
          opacity: 100;
        }
        &__button-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
        &__button {
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.5s ease;
          background-color: #f0f2f499;
          border-radius: 5px;
          &:hover {
            border: 1px solid #f5222e;
            background-color: #f0f2f4;
          }
        }
      }
    }
  }
  &__handle {
    transition: width 2s ease;
    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: flex-start;
      height: 46px;
      width: 20px;
      min-width: 20px;
      transition: all .3s ease;
      &__hide {
        width: 0;
        min-width: 0;
      }
      &__show {
        width: 20px;
        min-width: 20px;
      }
    }
  }
}
</style>
